import { Action } from '@ngrx/store';
import { PCGEntry } from 'app/api/pcg.api.service';

export enum PCGActionTypes {
  PCGRequested = '[PCG View] PCG requested',
  PCGLoaded = '[PCG API] PCG loaded',
  PCGCancelled = '[PCG API] PCG cancelled',
}

export class PCGRequested implements Action {
  readonly type = PCGActionTypes.PCGRequested;
}
export class PCGLoaded implements Action {
  readonly type = PCGActionTypes.PCGLoaded;
  constructor(public payload: { pcg: PCGEntry[]}) {}
}
export class PCGCancelled implements Action {
  readonly type = PCGActionTypes.PCGCancelled;
  constructor(public payload: { errorMessage: string }) {}
}

export type PCGActions = 
  PCGRequested
  | PCGLoaded
  | PCGCancelled;
